import {
    ChangeDetectionStrategy,
    Component,
    DoCheck,
    forwardRef,
    Injector,
    Input,
    ViewChild,
    ChangeDetectorRef,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NgControl,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Annotation } from 'src/app/acl-data/document/document.dto';
import { UserDataService } from 'src/app/acl-data/userData/user-data.service';
import { take } from 'rxjs/operators';
import { CommentDialogComponent } from '../comment-dialog/comment-dialog.component';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { MatSnackBar } from '@angular/material/snack-bar';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
    selector: 'app-comments-view',
    templateUrl: './comments-view.component.html',
    styleUrls: ['./comments-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CommentsViewComponent),
            multi: true,
        },
    ],
})
export class CommentsViewComponent implements ControlValueAccessor, DoCheck {
    comments: Annotation[];
    @Input() addButton = false;
    @Input() documentID: string;
    @Input() objectStore: string;
    newComment;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    displayedColumns: string[] = ['Date', 'Username', 'AnnotationText'];
    dataSource;

    onChanges = [];
    onTouched = [];
    touched = false;
    disabled = false;

    constructor(
        private injector: Injector,
        private userService: UserDataService,
        private documentService: DocumentService,
        public dialog: MatDialog,
        public snackBar: MatSnackBar
    ) { }

    addComment = event => {
        console.log('Adding Comment');

        const dialogRef = this.dialog.open(CommentDialogComponent, {
            width: '80%',
            // height: '80%',
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!!result) {
                console.log('Comment Added', result);

                this.formChanged(result);
                this.displayChange();

                if (this.documentID) {
                    this.documentService
                        .addComment(this.objectStore, this.documentID, result)
                        .subscribe(
                            _ => {
                                return;
                            },
                            err => {
                                console.log('Error adding comment : ', err);
                                const snak = this.snackBar.open(
                                    'Unable to update comment, please contact your administrator',
                                    'OK'
                                );
                            }
                        );
                }
            }
        });
    };

    displayChange() {
        if (this.comments) {
            this.dataSource = new MatTableDataSource<Annotation>(this.comments);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    formChanged = (input: any) => {
        this.userService.userData$.pipe(take(1)).subscribe(v => {
            const newComment: Annotation = {
                propertiesObj: {
                    AnnotationText: input,
                    AnnotationDate: new Date(),
                    AnnotationUser: v.username,
                },
            };

            const newComments = [newComment, ...this.comments];
            this.newComment = '';

            for (const change of this.onChanges) {
                change(newComments);
            }

            this.writeValue(newComments);
        });
    };

    writeValue(obj: Annotation[]): void {
        if (obj && obj.length > 0) {
            // console.log('Writing comment', obj);
            let objCopy = [...obj]
            let objCopySorted = objCopy.sort((a, b) => {
                const dateA = new Date(a.propertiesObj.AnnotationDate);
                const dateB = new Date(b.propertiesObj.AnnotationDate);
                return dateB.getTime() -dateA.getTime()  ;
            })
            this.comments = objCopySorted;
            this.displayChange();
        }
    }

    ngDoCheck() {
        const ngControl = this.injector.get(NgControl);
        if (!ngControl.control) {
            return;
        }
        this.touched = ngControl.control.touched;
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }
}
